import React from 'react';
import { connect } from 'react-redux';
import SafeReactPaginate from '../General/SafeReactPaginate';
import { editando, limpiarFiltros } from '../../actions/generalActios';
import {
  setId,
  setPlanes,
  fetchGrupoPlanes,
  fetchGrupoPlanesById,
  setPlanesDesdeBusqueda,
  setDataGrupoCopy,
  setDataGrupo,
  setFiltroGrupoPlanes,
  getGrupoPlanes
} from '../../actions/planesActions';
import PlanesListItem from './PlanesListItem';
import FiltroGrupoPlanes from './FiltroGrupoPlanes';
import BtnToggleFilter from "../General/Filter/BtnToggleFilter";
import BigSpinner from "../General/BigSpinner";
import { exportToExcel } from '../General/Excel/ExcelExportHelper';
import { toast } from '../../utilities/appToast';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import '../General/AdminListCard.css';

// Wrapper para usar hooks en class component
function ListPlanesWrapper(props) {
  const navigate = useNavigate();
  return <ListPlanes {...props} navigate={navigate} />;
}


class ListPlanes extends React.Component {

    toastXls = null;

    constructor(props) {
        super(props);
        this.state = {
            showFilter: this.props.filtro?.showFilter ?? false, 
            hideNoHay: false,
            datosExcelFormateados: null,
            isLoadingXls: false
        };
        this.INITIAL_REQUEST = {
            descripcion: "",
            page: 1,
            pageSize: 10
        };
    };

    componentDidMount() {
        if (this.props.isFilterClear) {
            this.buscarSinFiltro();
        } else {
            this.buscarConFiltro();
        }
    }
    
    buscarSinFiltro = () => {
        this.busquedaGrupoPlanes(this.INITIAL_REQUEST);
        this.props.setFiltroGrupoPlanes({ ...this.INITIAL_REQUEST, showFilter: this.state.showFilter });
        this.setState({ forcePage: 0 });
    }

    buscarConFiltro = () => {
        let params = {
            descripcion: this.props.filtro?.descripcion ?? "",
            pageSize: this.INITIAL_REQUEST.pageSize,
            page: 1,
        };
        // Si hay estado seleccionado, agregarlo como int
        if (typeof this.props.filtro?.estado === 'number') {
            params.estado = this.props.filtro.estado;
        }
        this.busquedaGrupoPlanes(params);
        this.props.setFiltroGrupoPlanes({ ...this.props.filtro, page: 1 });
        this.setState({ forcePage: 0 });
        if (this.props.isFilterClear) {
            this.setLimpiarFiltroFalse()
        }
    }

    busquedaGrupoPlanes = async (request) => {
        let params = request;
        await this.props.fetchGrupoPlanes({ params });
    }

    getEstadoGrupoLabel = (estado) => {
        if (estado === 0) return 'VIGENTE';
        if (estado === 2) return 'DESHABILITADO';
        return 'DESCONOCIDO';
    }

    busquedaGrupoPlanesParaExcel = async () => {
        this.toastXls = toast.info("Generando archivo Excel...", {
            autoClose: false,
            hideProgressBar: true,
        });

        this.setState({ isLoadingXls: true });
        let request = {
            pageSize: 500,
            page: 1,
            descripcion: this.props.filtro?.descripcion ?? "",
        }

        if (typeof this.props.filtro?.estado === 'number') {
            request.estado = this.props.filtro.estado;
        }

        try {
            const res = await getGrupoPlanes(request);
            const listaGrupoPlanes = Array.isArray(res?.data?.elementos)
                ? res.data.elementos
                : Array.isArray(res?.data?.paginationGrupoPlanes?.content)
                    ? res.data.paginationGrupoPlanes.content
                    : [];

            if (listaGrupoPlanes.length === 0) {
                toast.dismiss(this.toastXls);
                this.toastXls = null;
                toast.info("No se encontraron resultados para exportar.", {
                    autoClose: 3000,
                    hideProgressBar: true,
                });
                return;
            }

            this.setDatosExcelFormateados(listaGrupoPlanes);
        } catch (err) {
            toast.dismiss(this.toastXls);
            this.toastXls = null;
            toast.error("No se pudo generar el archivo Excel.", {
                autoClose: 4000,
                hideProgressBar: true,
            });
        } finally {
            this.setState({ isLoadingXls: false });
        }
    }

    setDatosExcelFormateados = (listaGrupoPlanes = []) => {
        const gruposFormateados = Array.isArray(listaGrupoPlanes)
            ? listaGrupoPlanes.map((grupo) => ({
                idGrupoPlan: grupo.idGrupoPlan,
                descripcion: grupo.descripcion,
                comision: grupo.comision,
                cantidadDeTipoPlanes: grupo.cantidadDeTipoPlanes,
                estado: this.getEstadoGrupoLabel(grupo.estado),
            }))
            : [];

        if (gruposFormateados.length === 0) {
            toast.update(this.toastXls, {
                render: "No se encontraron grupos para exportar.",
                type: toast.TYPE.INFO,
                autoClose: 3000,
                hideProgressBar: true,
            });
            return;
        }

        this.setState({ datosExcelFormateados: gruposFormateados });

        exportToExcel(gruposFormateados, 'Grupo Planes', 'grupoPlanes');

        toast.dismiss(this.toastXls);
        this.toastXls = null;
        toast.success("Descargando Archivo Excel ...", {
            autoClose: 3000,
            hideProgressBar: true,
        });
       
    }

    handlePageClick = (e) => {
        const selectedPage = e.selected + 1;
        const params = {
            descripcion: this.props.filtro?.descripcion ?? "",
            page: selectedPage,
            pageSize: this.INITIAL_REQUEST.pageSize
        };
        if (typeof this.props.filtro?.estado === 'number') {
            params.estado = this.props.filtro.estado;
        }
        this.busquedaGrupoPlanes(params);
        this.props.setFiltroGrupoPlanes({ ...this.props.filtro, numeroPagina: selectedPage });
        if (this.props.isFilterClear) {
            this.setLimpiarFiltroFalse()
        }
    };

    setLimpiarFiltroFalse = () => {
        this.props.limpiarFiltros({ ...this.props.emptyFilters, grupoPlanes: false });
    }

    onGrupoPlan = (id) => {
        this.props.editando(true);
        this.props.setPlanesDesdeBusqueda([]);
        this.props.setDataGrupoCopy({})
        this.props.setPlanes([]);
        this.props.setId(id);
        this.props.navigate(`/Planes/Editar/${id}`);
    }

    goToPlanesNuevo = () => {
        this.props.fetchGrupoPlanesById({ idGrupoPlan: 0 });
        this.props.setDataGrupo({ descripcion: "", comision: "" });
        this.props.setPlanesDesdeBusqueda([]);
        this.props.setId(0);
        this.props.editando(false);
        this.props.navigate("/Planes/Nuevo");
    }

    handleShowFilter = (value) => {
        this.setState({ showFilter: value });
        this.props.setFiltroGrupoPlanes({ ...this.props.filtro, showFilter: value });
    }

    render() {
        const { grupoPlanes } = this.props;
        const hasResults = grupoPlanes?.length > 0;
        const pageCount = Math.ceil(this.props.cantidadTotal / 10);
        const shouldShowPagination = hasResults;

        return (
            <div className="container">
                <div className="row mb-3 mb-md-4 align-items-center py-3 px-2 rounded admin-page-heading" style={{ background: 'linear-gradient(to right, #f8f9fa 0%, #fff 100%)', borderLeft: '4px solid var(--rojo-megatone, #c00)' }}>

                    <div className="col-12 col-md-5 col-lg-4">
                        <h4 className="mb-0 text-themecolor color-rojo-megatone fw-bold">Grupos de planes</h4>
                        <p className="small text-body-secondary mb-0 mt-1 d-none d-md-block">Comisiones y planes asociados a cada grupo.</p>
                    </div>

                    <div className="button-group col-12 col-md-7 col-lg-8 text-md-end mt-2 mt-md-0 d-flex flex-wrap align-items-center justify-content-md-end gap-2">
                        {this.props.userType.isAdminMod && (
                            <>
                                {/* Botón para exportar los datos */}
                                <button
                                    type="button"
                                    //onClick={this.busquedaGrupoPlanesParaExcel(this.INITIAL_REQUEST)}
                                    onClick={() => this.busquedaGrupoPlanesParaExcel()}
                                    className="btn btn-sm btn-green"
                                    disabled={this.state.isLoadingXls}
                                >
                                Exportar a Excel
                                </button>

                            </>
                        )}

                        <button
                            type="button"
                            onClick={this.goToPlanesNuevo}
                            className="btn btn-sm btn-green"
                        >
                            <i className="fa fa-plus-circle mx-1" /> Crear Grupo
                        </button>

                        <BtnToggleFilter
                            show={this.state.showFilter}
                            handleShow={() => this.handleShowFilter(!this.state.showFilter)}
                        />
                    </div>

                </div>

                <div hidden={!this.state.showFilter} className="card filter-card shadow-sm mb-3">
                    <FiltroGrupoPlanes 
                        className="col-12"
                        getPlanes={this.buscarConFiltro}
                        clearFilter={this.buscarSinFiltro}
                    />
                </div>

                <div hidden={!this.state.hideNoHay}>
                    <h5 className="d-flex justify-content-center m-t-40 m-b-40">No hay grupo de planes</h5>
                </div>

                {this.props.isLoading ? <BigSpinner message="Cargando grupos de planes..." /> :
                    <div className="admin-list-stack">
                        {hasResults ? (
                            grupoPlanes.map((plan, i) => (
                                <PlanesListItem
                                    key={plan.idGrupoPlan ?? i}
                                    idGrupo={plan.idGrupoPlan}
                                    idUsuario={this.props.userId}
                                    nombre={plan.descripcion}
                                    cantidadPlanes={plan.cantidadDeTipoPlanes}
                                    comision={plan.comision}
                                    estado={plan.estado}
                                    filtro={this.props.filtro}
                                    onEstadoActualizado={this.buscarConFiltro}
                                    onRowClick={() => this.onGrupoPlan(plan.idGrupoPlan)}
                                />
                            ))
                        ) : (
                            <div className="text-center py-4">
                                <h5 className="text-body-secondary mb-0">No se encontraron resultados</h5>
                                <p className="small text-body-secondary mt-2 mb-0">Probá ajustando los filtros de búsqueda.</p>
                            </div>
                        )}
                    </div>
                }

                {shouldShowPagination && (
                    <div className="d-flex justify-content-center">
                        <SafeReactPaginate
                            previousLabel={"Anterior"}
                            nextLabel={"Siguiente"}
                            breakLabel={"..."}
                            breakClassName={"break-me"}
                            pageCount={pageCount}
                            marginPagesDisplayed={10}
                            pageRangeDisplayed={10}
                            onPageChange={this.handlePageClick}
                            containerClassName={"pagination"}
                            subContainerClassName={"pages pagination"}
                            activeClassName={"active"}
                            forcePage={typeof this.props.page === 'number' ? this.props.page - 1 : 0}
                        />
                    </div>
                )}
            </div>
        );
    }
}
ListPlanes.propTypes = {
    // Hooks props
    navigate: PropTypes.func,
    // Redux props
    filtro: PropTypes.oneOfType([PropTypes.shape({
        showFilter: PropTypes.bool,
        descripcion: PropTypes.string,
        estado: PropTypes.number,
    }), PropTypes.array]),
    isFilterClear: PropTypes.bool,
    userType: PropTypes.shape({
        isAdminMod: PropTypes.bool,
    }),
    userId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    editando: PropTypes.func,
    emptyFilters: PropTypes.object,
    grupoPlanes: PropTypes.array,
    isLoading: PropTypes.bool,
    cantidadTotal: PropTypes.number,
    page: PropTypes.number,
    // Actions props
    setFiltroGrupoPlanes: PropTypes.func,
    fetchGrupoPlanes: PropTypes.func,
    limpiarFiltros: PropTypes.func,
    setPlanesDesdeBusqueda: PropTypes.func,
    setDataGrupoCopy: PropTypes.func,
    setPlanes: PropTypes.func,
    setId: PropTypes.func,
    fetchGrupoPlanesById: PropTypes.func,
    setDataGrupo: PropTypes.func,
}

const mapStateToProps = (state) => {
    const gp = state.planes?.grupoPlanes ?? {};
    const elementos =
        Array.isArray(gp?.elementos) ? gp.elementos :
            Array.isArray(gp?.Elementos) ? gp.Elementos :
                Array.isArray(gp?.content) ? gp.content :
                    Array.isArray(gp?.Content) ? gp.Content : [];
    return {
    seller: state.general.idSeller,
    userId: state.general.userId,
    userType: state.general.userType,
    isLoading: state.planes.loadingPlanes,
    grupoPlanes: elementos,
    cantidadTotal: gp?.total ?? gp?.Total ?? gp?.cantidadTotal ?? gp?.CantidadTotal ?? elementos.length,
    filtro: state.planes.filtro,
    page: gp?.page ?? gp?.Page ?? gp?.numeroPagina ?? gp?.NumeroPagina ?? 1,
    isFilterClear: state.general.limpiar.grupoPlanes,
    emptyFilters: state.general.limpiar,
    };
};

export default connect(mapStateToProps, {
    setId,
    editando,
    setPlanes,
    setDataGrupo,
    setDataGrupoCopy,
    fetchGrupoPlanes,
    fetchGrupoPlanesById,
    setPlanesDesdeBusqueda,
    setFiltroGrupoPlanes,
    limpiarFiltros
})(ListPlanesWrapper);
